import RelatedRegionsModal from '@organisms/RelatedRegionsModal';
import RelatedCountriesModal from '@organisms/RelatedCountriesModal';
import RelatedCompetitionModal from '@organisms/RelatedCompetitionModal';
import RelatedAthleteModal from '@organisms/RelatedAthleteModal';
import RelatedDisciplineModal from '@organisms/RelatedDisciplineModal';
import RelatedArticleModal from '@organisms/RelatedArticleModal';
import RelatedEventModal from '@organisms/RelatedEventModal';
import RelatedUrlModal from '@organisms/RelatedUrlModal';
import RelatedMinisitesModal from '@organisms/RelatedMiniSitesModal';
import RelatedLocationModal from '@organisms/RelatedLocationModal';
import RelatedTagModal from '@organisms/RelatedTagModal';
import RelatedCategoryModal from '@organisms/RelatedCategoryModal';
import RelatedAgeGroupModal from '@organisms/RelatedAgeGroupModal';
import RelatedActivityGroupModal from '@organisms/RelatedActivityGroupModal';
import RelatedAthleticsSkillModal from '@organisms/RelatedAthleticsSkillModal';
import RelatedFundamentalSkillModal from '@components/organisms/RelatedFundamentalSkillModal';
import RelatedKidsAthleticsValueModal from '@organisms/RelatedKidsAthleticsValueModal';
import RelatedResourceTypeModal from '@organisms/RelatedResourceTypeModal';
import RelatedOregonContentTrackModal from '@organisms/RelatedOregonContentTrackModal';
import RelatedOregonSuggestedGradeLevel from '@organisms/RelatedOregonSuggestedGradeLevel';
import RelatedOregonSubjectArea from '@organisms/RelatedOregonSubjectArea';
import RelatedOregonTrackAndFieldFocus from '@organisms/RelatedOregonTrackAndFieldFocus';
import RelatedOregonActivitySpace from '@organisms/RelatedOregonActivitySpace';
import RelatedOregonActivityType from '@organisms/RelatedOregonActivityType';
import RelatedMedicalCare from '@organisms/RelatedMedicalCare';
import RelatedRiskMitigation from '@organisms/RelatedRiskMitigation';
import RelatedTrainingAndPerformance from '@organisms/RelatedTrainingAndPerformance';
import RelatedEnvironment from '@organisms/RelatedEnvironment';
import RelatedSpecialPopulations from '@organisms/RelatedSpecialPopulations';
import RelatedPlaylist from '@components/organisms/RelatedPlaylistModal';
// TODO: implement when API is ready
// import RelatedDocumentModal from './RelatedDocumentModal';

export const RELATED_CONTENT_TYPE = {
  ATHLETES: 'relatedAthletes',
  DISCIPLINES: 'relatedDisciplines',
  COMPETITIONS: 'relatedCompetitions',
  CHAMPIONSHIP_EVENTS: 'relatedChampionshipEvents',
  ARTICLES: 'relatedArticles',
  EVENTS: 'relatedEvents',
  URLS: 'relatedUrls',
  MINISITES: 'relatedMinisites',
  COUNTRIES: 'relatedCountries',
  REGIONS: 'relatedRegions',
  LOCATIONS: 'relatedLocations',
  TAGS: 'tags',
  USER_CATEGORIES: 'userCategories',
  AGE_GROUPS: 'ageGroups',
  ACTIVITY_GROUP: 'activityGroup',
  ATHLETICS_SKILL: 'athleticsSkill',
  FUNDAMENTAL_SKILLS: 'fundamentalSkill',
  KIDS_ATHLETICS_VALUES: 'kidsAthleticsValues',
  RESOURCE_TYPE: 'resourceType',
  OREGON_CONTENT_TRACK: 'contentTrack',
  OREGON_SUGGESTED_GRADE_LEVEL: 'suggestedGradeLevel',
  OREGON_SUBJECT_AREA: 'subjectArea',
  OREGON_TRACK_FIELD_FOCUS: 'trackFieldFocus',
  OREGON_ACTIVITY_SPACE: 'activitySpace',
  OREGON_ACTIVITY_TYPE: 'activityType',

  MEDICAL_CARE: 'medicalCare',
  RISK_MITIGATION: 'riskMitigation',
  TRAINING_AND_PERFORMANCE: 'trainingAndPerformance',
  ENVIRONMENT: 'environment',
  SPECIAL_POPULATION: 'specialPopulations',
  PLAYLISTS: 'relatedPlaylist',
};

export const RELATED_CONTENTS = [
  {
    type: RELATED_CONTENT_TYPE.ATHLETES,
    label: 'Athletes',
    renderItem: RelatedAthleteModal.Item,
    modal: RelatedAthleteModal,
  },
  {
    type: RELATED_CONTENT_TYPE.DISCIPLINES,
    label: 'Disciplines',
    renderItem: RelatedDisciplineModal.Item,
    modal: RelatedDisciplineModal,
  },
  {
    type: RELATED_CONTENT_TYPE.COMPETITIONS,
    label: 'Competitions',
    renderItem: RelatedCompetitionModal.Item,
    modal: RelatedCompetitionModal,
  },
  {
    type: RELATED_CONTENT_TYPE.ARTICLES,
    label: 'Articles',
    renderItem: RelatedArticleModal.Item,
    modal: RelatedArticleModal,
  },
  {
    type: RELATED_CONTENT_TYPE.EVENTS,
    label: 'Events',
    renderItem: RelatedEventModal.Item,
    modal: RelatedEventModal,
  },
  {
    type: RELATED_CONTENT_TYPE.URLS,
    label: 'Urls',
    renderItem: RelatedUrlModal.Item,
    modal: RelatedUrlModal,
  },
  {
    type: RELATED_CONTENT_TYPE.MINISITES,
    label: 'Minisites',
    renderItem: RelatedMinisitesModal.Item,
    modal: RelatedMinisitesModal,
  },
  {
    type: RELATED_CONTENT_TYPE.COUNTRIES,
    label: 'Countries',
    renderItem: RelatedCountriesModal.Item,
    modal: RelatedCountriesModal,
  },
  {
    type: RELATED_CONTENT_TYPE.REGIONS,
    label: 'Regions',
    renderItem: RelatedRegionsModal.Item,
    modal: RelatedRegionsModal,
  },
  {
    type: RELATED_CONTENT_TYPE.LOCATIONS,
    label: 'Locations',
    renderItem: RelatedLocationModal.Item,
    modal: RelatedLocationModal,
  },
  {
    type: RELATED_CONTENT_TYPE.TAGS,
    label: 'Tags',
    renderItem: RelatedTagModal.Item,
    modal: RelatedTagModal,
  },
  {
    type: RELATED_CONTENT_TYPE.USER_CATEGORIES,
    label: 'User category',
    renderItem: RelatedCategoryModal.Item,
    modal: RelatedCategoryModal,
  },
  {
    type: RELATED_CONTENT_TYPE.AGE_GROUPS,
    label: 'Levels',
    renderItem: RelatedAgeGroupModal.Item,
    modal: RelatedAgeGroupModal,
  },
  {
    type: RELATED_CONTENT_TYPE.ACTIVITY_GROUP,
    label: 'Activity Group', // label renamed but left as SKILLS so no work for BE
    renderItem: RelatedActivityGroupModal.Item,
    modal: RelatedActivityGroupModal,
  },
  {
    type: RELATED_CONTENT_TYPE.ATHLETICS_SKILL,
    label: 'Athletics Skills', // label renamed but left as Discipline so no work for BE
    renderItem: RelatedAthleticsSkillModal.Item,
    modal: RelatedAthleticsSkillModal,
  },
  {
    type: RELATED_CONTENT_TYPE.FUNDAMENTAL_SKILLS,
    label: 'Fundamental skills',
    renderItem: RelatedFundamentalSkillModal.Item,
    modal: RelatedFundamentalSkillModal,
  },
  {
    type: RELATED_CONTENT_TYPE.KIDS_ATHLETICS_VALUES,
    label: 'Kids athletics values',
    renderItem: RelatedKidsAthleticsValueModal.Item,
    modal: RelatedKidsAthleticsValueModal,
  },
  {
    type: RELATED_CONTENT_TYPE.RESOURCE_TYPE,
    label: 'Resource Type',
    renderItem: RelatedResourceTypeModal.Item,
    modal: RelatedResourceTypeModal,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_CONTENT_TRACK,
    label: 'Content track',
    renderItem: RelatedOregonContentTrackModal.Item,
    modal: RelatedOregonContentTrackModal,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_SUGGESTED_GRADE_LEVEL,
    label: 'Suggested grade level',
    renderItem: RelatedOregonSuggestedGradeLevel.Item,
    modal: RelatedOregonSuggestedGradeLevel,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_SUBJECT_AREA,
    label: 'Subject area',
    renderItem: RelatedOregonSubjectArea.Item,
    modal: RelatedOregonSubjectArea,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_TRACK_FIELD_FOCUS,
    label: `Track & field focus`,
    renderItem: RelatedOregonTrackAndFieldFocus.Item,
    modal: RelatedOregonTrackAndFieldFocus,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_ACTIVITY_SPACE,
    label: `Activity space`,
    renderItem: RelatedOregonActivitySpace.Item,
    modal: RelatedOregonActivitySpace,
  },
  {
    type: RELATED_CONTENT_TYPE.OREGON_ACTIVITY_TYPE,
    label: `Activity type`,
    renderItem: RelatedOregonActivityType.Item,
    modal: RelatedOregonActivityType,
  },
  {
    type: RELATED_CONTENT_TYPE.MEDICAL_CARE,
    label: `Medical Care`,
    renderItem: RelatedMedicalCare.Item,
    modal: RelatedMedicalCare,
  },
  {
    type: RELATED_CONTENT_TYPE.RISK_MITIGATION,
    label: `Risk Mitigation`,
    renderItem: RelatedRiskMitigation.Item,
    modal: RelatedRiskMitigation,
  },
  {
    type: RELATED_CONTENT_TYPE.TRAINING_AND_PERFORMANCE,
    label: `Training & Performance`,
    renderItem: RelatedTrainingAndPerformance.Item,
    modal: RelatedTrainingAndPerformance,
  },
  {
    type: RELATED_CONTENT_TYPE.ENVIRONMENT,
    label: `Environment`,
    renderItem: RelatedEnvironment.Item,
    modal: RelatedEnvironment,
  },
  {
    type: RELATED_CONTENT_TYPE.SPECIAL_POPULATION,
    label: `Special Populations`,
    renderItem: RelatedSpecialPopulations.Item,
    modal: RelatedSpecialPopulations,
  },
  {
    type: RELATED_CONTENT_TYPE.PLAYLISTS,
    label: `Playlists`,
    renderItem: RelatedPlaylist.Item,
    modal: RelatedPlaylist,
  },
  // TODO: implement when API is ready
  // {
  //   name: RELATED_CONTENT_TYPE.DOCUMENTS,
  //   label: 'Urls',
  //   renderItem: RelatedDocumentModal.Item,
  //   modal: RelatedDocumentModal,
  // }
];

export const RELATED_CONTENT_BY_TYPE = RELATED_CONTENTS.reduce(
  (acc, relatedContent) => ({ ...acc, [relatedContent.type]: relatedContent }),
  {},
);

export const RELATED_CHAMPIONSHIP_EVENT_BY_SEX = {
  menEvents: { label: `Men's events`, sexCode: 'M' },
  womenEvents: { label: `Women's events`, sexCode: 'W' },
  mixedEvents: { label: `Mixed's events`, sexCode: 'X' },
};
